import React, { useEffect, useState } from "react";
import http from "../../../http";
// import Modal from "react-modal";
import MaterialTable from "material-table";
import Swal from "sweetalert2";
import { memberLang } from "../../../Components/language/pages/memberLang";
import useLanguage from "../../../Components/language/useLanguage";
import { Modal as ReactModal } from "../../../Components/Common/Modal";
import {
  FaRegCalendarCheck,
  FaRegCalendarTimes,
  FaRegEdit,
} from "react-icons/fa";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { FiTrash } from "react-icons/fi";
export default function DealersTargetSale() {
  const [update, setUpdate] = useState("members");
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [dealers, setDealers] = useState([]);
  const lan = useLanguage(memberLang);
  const [months, setMonths] = useState([
    { value: "January", month: "January", target_sales: 0, remarks: "" },
    { value: "February", month: "February", target_sales: 0, remarks: "" },
    { value: "March", month: "March", target_sales: 0, remarks: "" },
    { value: "April", month: "April", target_sales: 0, remarks: "" },
    { value: "May", month: "May", target_sales: 0, remarks: "" },
    { value: "June", month: "June", target_sales: 0, remarks: "" },
    { value: "July", month: "July", target_sales: 0, remarks: "" },
    { value: "August", month: "August", target_sales: 0, remarks: "" },
    { value: "September", month: "September", target_sales: 0, remarks: "" },
    { value: "October", month: "October", target_sales: 0, remarks: "" },
    { value: "November", month: "November", target_sales: 0, remarks: "" },
    { value: "December", month: "December", target_sales: 0, remarks: "" },
  ]);
  useEffect(() => {
    http.get(`sales-target`).then((res) => {
      setData(res.data.data);
      setIsLoading(false);
    });
    http.get(`customers/dealer`).then((res) => {
      setDealers(res.data.data);
    });
  }, [update]);
  const columns = [
    {
      title: lan?.sl,
      field: "",
      render: (row) => (
        <div className="text-center">{row.tableData.id + 1}</div>
      ),
      width: "20 !important",
    },

    {
      title: lan?.name,
      field: `dealer.member_name`,
    },
    {
      title: lan?.year,
      field: ``,
      render: (row) => <div>{moment(row?.year).format("YYYY")}</div>,
    },
    {
      title: lan?.month,
      field: `month`,
    },
    {
      title: lan?.targetSale,
      field: `target_sales`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.remarks,
      field: `contact_person`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.status,
      field: `short_name`,
      render: (row) => (
        <div>
          {" "}
          {Number(row?.status) === 1 ? (
            <span class="badge bg-success">Open</span>
          ) : (
            <span class="badge bg-danger">Closed</span>
          )}
        </div>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },

    {
      title: lan?.action,
      field: "patient",
      render: (row) => (
        <div className="text-center">
          <button
            onClick={() => closeRowData(row.id)}
            className="btn btn-sm action-btn"
          >
            {Number(row?.status) === 1 ? (
              <FaRegCalendarTimes fontSize={18} />
            ) : (
              <FaRegCalendarCheck className="text-success" fontSize={18} />
            )}
          </button>
          <button
            onClick={() => editData(row)}
            className="btn btn-sm action-btn ms-1"
          >
            <FaRegEdit fontSize={18} />
          </button>
          &nbsp;
          <button
            onClick={() => deleteRowData(row.id)}
            className="btn btn-sm action-btn"
          >
            <FiTrash fontSize={18} />
          </button>
        </div>
      ),
      cellStyle: {
        width: "5%",
        textAlign: "center",
      },
    },
  ];
  const [member, setMember] = useState({
    member_id: "",
    year: new Date(),
    member_type: "dealer",
  });
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (member?.member_id && member?.year) {
      http
        .get(`dealer-sales-target/${member?.member_id}/${member?.year}`)
        .then((res) => {
          if (res?.data?.data?.length > 0) {
            setMonths(res?.data?.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [member?.member_id, member?.year]);
  const handleSubmit = () => {
    http
      .post("save-sales-target", { ...member, months: months })
      .then((res) => {
        if (res.data.status === 200) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: `<div><h1 style={{color:'green'}}>Congratulations!</h1><h4>${member.member_name}</h4> <h6>You are now our dealer</h6></div>`,
            timer: 2500,
          });

          setIsOpen(false);
          setUpdate(!update);
          setMember({
            member_id: "",
            year: new Date(),
          });
        } else {
        }
      });
  };

  const handleMonthChange = (e, i) => {
    const { name, value } = e.target;
    const exist = [...months];
    exist[i][name] = value;
    setMonths(exist);
  };
  const editData = (data) => {
    setMember({
      ...member,
      member_id: data?.dealer_id,
      year: data?.year,
    });
    setIsOpen(true);
  };
  const closeRowData = (id) => {
    Swal.fire({
      title: lan?.warning,
      text: lan?.youWontRevertIt,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes Close it!",
    }).then((result) => {
      if (result.isConfirmed) {
        http.post(`close-sales-target/${id}`).then((res) => {
          setUpdate(!update);
          setIsOpen(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    });
  };
  const deleteRowData = (id) => {
    Swal.fire({
      title: lan?.warning,
      text: lan?.youWontRevertIt,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.yes,
    }).then((result) => {
      if (result.isConfirmed) {
        http.post(`delete-sales-target/${id}`).then((res) => {
          setUpdate(!update);
          setIsOpen(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    });
  };
  const closeModal = () => {
    setIsOpen(false);
    setMember({
      member_id: "",
      year: new Date(),
      member_type: "dealer",
    });
  };
  console.log(months);
  return (
    <div className="page-content adjustment-type-table">
      <div className="custom-card p-2 d-flex justify-content-between mb-2 align-items-center">
        <h6>
          {lan?.dealers} {lan?.target_sales}
        </h6>
        <div>
          <button
            style={{ marginTop: "1px" }}
            onClick={() => setIsOpen(true)}
            className="btn btn-sm btn-primary float-end"
          >
            {lan?.add}
          </button>
        </div>
      </div>
      <div className="data-table-container">
        <MaterialTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          options={{
            search: true,
            showTitle: false,
            searchFieldAlignment: "left",
            pageSize: 10,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [5, 10, 20, 50, 100],
          }}
        />
      </div>

      <ReactModal isOpen={isOpen} onClose={closeModal} size="full" width="100%">
        <ReactModal.Header onClose={closeModal}>
          <ReactModal.Title>{lan?.target_sales}</ReactModal.Title>
        </ReactModal.Header>
        <ReactModal.Body styles={{ minHeight: "400px" }}>
          <div className="product_modal">
            <div className="new-member-reg p-2">
              <div className="row">
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label>
                      {lan?.select} {lan?.dealer}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={dealers}
                      placeholder={lan?.select}
                      onChange={(e) =>
                        setMember({
                          ...member,
                          member_id: e.id,
                        })
                      }
                      getOptionLabel={(unPaidInvoices) =>
                        `${unPaidInvoices.member_name}`
                      }
                      getOptionValue={(unPaidInvoices) =>
                        `${unPaidInvoices.id}`
                      }
                      value={dealers?.filter(
                        (unPaidInvoices) =>
                          unPaidInvoices.id === member?.member_id
                      )}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label>
                      {lan?.select} {lan?.year}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <ReactDatePicker
                      className="form-control form-control-sm"
                      selected={
                        member?.year ? new Date(member?.year) : new Date()
                      }
                      dateFormat="yyyy"
                      showYearPicker
                      onChange={(date) => {
                        setMember({
                          ...member,
                          year: date,
                        });
                      }}
                    />
                  </div>
                </div>
                {months?.map((item, index) => (
                  <div className="col-6" key={index}>
                    <div className="row mb-2">
                      <div className="col-2">
                        <div className="d-flex justify-content-between">
                          <label htmlFor="">{item?.month}</label>
                        </div>
                      </div>
                      <div className="col-10">
                        <div className="row">
                          <div className="col-6">
                            <div className="row">
                              <div className="col-5">
                                <label htmlFor="">{lan?.target_sales}</label>
                              </div>
                              <div className="col-7">
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  name="target_sales"
                                  value={
                                    item?.target_sales > 0
                                      ? item?.target_sales
                                      : ""
                                  }
                                  onChange={(e) => handleMonthChange(e, index)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="row">
                              <div className="col-4">
                                <label htmlFor="">{lan?.remarks}</label>
                              </div>
                              <div className="col-8">
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  name="remarks"
                                  value={item?.remarks}
                                  onChange={(e) => handleMonthChange(e, index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ReactModal.Body>
        <ReactModal.Footer>
          <button onClick={handleSubmit} className="btn btn-sm btn-primary">
            {" "}
            Save
          </button>
        </ReactModal.Footer>
      </ReactModal>
    </div>
  );
}
